export const REASON_CODES = {
    SYSTEM_EXCEPTION: 0,
    SUCCESS: 1,
    SUCCESS_WITH_ERRORS: 2,
    INVALID_IMAGE: 3,
    COOKIE_NOT_LOGGED: 4,
    ACCOUNT_CHECKPOINTED: 5,
    CANNOT_UPLOAD_IMAGE_TO_FACEBOOK: 6,
    CANNOT_CONNECT_TO_PROXY: 7,
    CANNOT_FIND_ACCESS_TOKEN: 8,
    FACEBOOK_RETURN_ERRORS: 9,
    IMAGE_IS_MISSING: 10,
    PAGE_NOT_OWN: 11,
    FACEBOOK_SAID_NAME_NOT_VALID: 12,
    FACEBOOK_SAID_NO_NAME_OPTION: 13,
    FACEBOOK_TEMPORARY_BLOCKED: 14,
    REQUIRED_ACCESS_TOKEN: 17,
    TOKENS_EXPIRED: 20,
    GROUP_POSTING_NOT_ALLOWED: 21,
    UPLOAD_IMAGE_TEMPORARILY_BANNED: 22,
    INVALID_VIDEO: 23,
    CANNOT_FIND_ID: 24,
    INVALID_REQUEST_FORMAT: 25,
};

export const ACTIONS =
    [
        {
            name: "get_id",
            doc: "Get Facebook Group/Page/User ID from profile URL or username.",
            params: [
                { key: "input", type: "text", required: true, doc: "URL or username." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": { "id": "{Group/Page/User_ID}", "type": "{group/page/user}" } },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.SUCCESS,
                REASON_CODES.CANNOT_FIND_ID,
            ],
        },
        {
            name: "page_post_to_feed",
            doc: "Publish post to your Page's feed",
            params: [
                { key: "page_id", type: "text", required: true, doc: "Facebook page ID to post to." },
                { key: "content", type: "text", required: true, doc: "Content to post." },
                { key: "images", type: "array", required: false, doc: "Images Base64 or URL. Seperated by comma ','" },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": {"id": "|POST_ID|"} },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
            ],
        },
        {
            name: "page_comment_to_post",
            doc: "Comment to a post by your Page",
            params: [
                { key: "page_id", type: "text", required: true, doc: "Facebook page ID to post to." },
                { key: "post_id", type: "text", required: true, doc: "Facebook post ID to comment on." },
                { key: "content", type: "text", required: true, doc: "Content to comment." },
                { key: "image", type: "text", required: false, doc: "Image Base64 or URL." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": {"id": "|COMMENT_ID|"} },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
            ],
        },
        {
            name: "post_to_my_feed",
            doc: "Post content, images, or video to your own Facebook feed.",
            params: [
                { key: "content", type: "text", required: true, doc: "Content to post." },
                { key: "images", type: "array", required: false, doc: "Images Base64 or URL. Seperated by comma ','" },
                { key: "preset_id", type: "text", required: false, doc: "Preset id to use." },
                { key: "video_url", type: "text", required: false, doc: "Video to post. If set, 'images' will be ignored." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": { "id": "{POST_ID}", "url": "{POST_URL}" } },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
                REASON_CODES.INVALID_IMAGE,
                REASON_CODES.INVALID_VIDEO,
                REASON_CODES.UPLOAD_IMAGE_TEMPORARILY_BANNED,
                REASON_CODES.CANNOT_UPLOAD_IMAGE_TO_FACEBOOK,
            ],
        },
        {
            name: "post_reels",
            doc: "Upload a video as a Facebook Reel with a caption.",
            params: [
                { key: "content", type: "text", required: true, doc: "Caption for the reel." },
                { key: "video_url", type: "text", required: true, doc: "Video URL to upload as reel." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": { "id": "{REEL_ID}", "video_id": "{VIDEO_ID}", "url": "https://www.facebook.com/{REEL_ID}" } },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
                REASON_CODES.INVALID_VIDEO,
            ],
        },
        {
            name: "post_to_group",
            doc: "Post content, images, or video to a Facebook group.",
            params: [
                { key: "group_id", type: "text", required: true, doc: "Facebook group ID." },
                { key: "content", type: "text", required: true, doc: "Content to post." },
                { key: "images", type: "array", required: false, doc: "Images Base64 or URL. Seperated by comma ','" },
                { key: "preset_id", type: "text", required: false, doc: "Preset id to use." },
                { key: "video_url", type: "text", required: false, doc: "Video to post. If set, 'images' will be ignored." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": { "id": "{POST_ID}", "url": "https://www.facebook.com/{POST_ID}", "is_verified": false } },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
                REASON_CODES.INVALID_IMAGE,
                REASON_CODES.INVALID_VIDEO,
                REASON_CODES.UPLOAD_IMAGE_TEMPORARILY_BANNED,
                REASON_CODES.CANNOT_UPLOAD_IMAGE_TO_FACEBOOK,
                REASON_CODES.GROUP_POSTING_NOT_ALLOWED,
            ],
        },
        {
            name: "comment_to_post",
            doc: "Comment on a Facebook post, with optional images.",
            params: [
                { key: "post_id", type: "text", required: true, doc: "ID of the post to comment on." },
                { key: "content", type: "text", required: true, doc: "Content of the comment." },
                { key: "image", type: "text", required: false, doc: "Image URL or Base64 string to attach to the comment." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": { "id": "{COMMENT_ID}", "url": "{COMMENT_URL}", "content": "{COMMENT_CONTENT}", "timestamp": 1700000000 } },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
                REASON_CODES.INVALID_IMAGE,
                REASON_CODES.CANNOT_UPLOAD_IMAGE_TO_FACEBOOK,
                REASON_CODES.UPLOAD_IMAGE_TEMPORARILY_BANNED,
            ],
        },
        {
            name: "reply_to_comment",
            doc: "Reply to a comment on a Facebook post, with optional image.",
            params: [
                { key: "parent_post_id", type: "text", required: true, doc: "ID of the parent post." },
                { key: "comment_id", type: "text", required: true, doc: "ID of the comment to reply to." },
                { key: "content", type: "text", required: true, doc: "Content of the reply." },
                { key: "image", type: "text", required: false, doc: "Image URL or Base64 string to attach to the reply." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": { "id": "{REPLY_ID}", "url": "{REPLY_URL}", "content": "{REPLY_CONTENT}", "timestamp": 1700000000 } },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
                REASON_CODES.INVALID_IMAGE,
                REASON_CODES.CANNOT_UPLOAD_IMAGE_TO_FACEBOOK,
                REASON_CODES.UPLOAD_IMAGE_TEMPORARILY_BANNED,
            ],
        },
        {
            name: "change_avatar",
            doc: "Change the Facebook account's avatar (profile picture).",
            params: [
                { key: "image", type: "text", required: true, doc: "Image URL or Base64 string of the new avatar image." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": { "image_id": "{IMAGE_ID}" } },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
                REASON_CODES.IMAGE_IS_MISSING,
                REASON_CODES.INVALID_IMAGE,
                REASON_CODES.CANNOT_UPLOAD_IMAGE_TO_FACEBOOK,
                REASON_CODES.UPLOAD_IMAGE_TEMPORARILY_BANNED,
            ],
        },
        {
            name: "change_name",
            doc: "Change the Facebook account's name.",
            params: [
                { key: "first", type: "text", required: true, doc: "First name." },
                { key: "last", type: "text", required: true, doc: "Last name." },
                { key: "middle", type: "text", required: false, doc: "Middle name." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": {} },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
                REASON_CODES.FACEBOOK_SAID_NAME_NOT_VALID,
                REASON_CODES.FACEBOOK_SAID_NO_NAME_OPTION,
            ],
        },
        {
            name: "change_bio",
            doc: "Change the Facebook account's biography.",
            params: [
                { key: "bio", type: "text", required: true, doc: "New biography content." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": {} },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
            ],
        },
        {
            name: "add_friend",
            doc: "Send a friend request to a Facebook user by user ID.",
            params: [
                { key: "uid", type: "text", required: true, doc: "Facebook user ID to add as friend." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": {} },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
            ],
        },
        {
            name: "join_group",
            doc: "Join a Facebook group by group ID.",
            params: [
                { key: "group_id", type: "text", required: true, doc: "Facebook group ID to join." },
            ],
            response: { "status": { "code": 1, "message": "SUCCESS" }, "data": {} },
            posible_code: [
                REASON_CODES.INVALID_REQUEST_FORMAT,
                REASON_CODES.CANNOT_CONNECT_TO_PROXY,
                REASON_CODES.COOKIE_NOT_LOGGED,
                REASON_CODES.ACCOUNT_CHECKPOINTED,
                REASON_CODES.FACEBOOK_RETURN_ERRORS,
                REASON_CODES.SUCCESS_WITH_ERRORS,
                REASON_CODES.SUCCESS,
            ],
        },
    ];

export const EXECUTOR_WRAPPER = (data) => {
    return {
        "success": true,
        "message": "Query to service Facebook Action successfully",
        "data": data
    }
}